export default [
    {
        "name": "望舌质",
        "index": "1",
        "ifShowSecond": true,
        "children": [
            {
                "name": "舌神",
                "label": "神",
                "ifShowThird": false,
                "index": "1.1",
                "children": [{ "name": "荣舌", "index": "1.1.1" }, { "name": "枯舌", "index": "1.1.2" }]
            },
            {
                "name": "舌色",
                "label": "色",
                "ifShowThird": false,
                "index": "1.2",
                "children": [
                    { "name": "淡红舌", "index": "1.2.1" },
                    { "name": "红舌", "index": "1.2.2" },
                    { "name": "绛舌", "index": "1.2.3" },
                    { "name": "青紫舌", "index": "1.2.4" },
                    { "name": "淡白舌", "index": "1.2.5" }
                ]
            },
            {
                "name": "舌形",
                "label": "形",
                "ifShowThird": false,
                "index": "1.3",
                "children": [
                    { "name": "苍老舌", "index": "1.3.1" },
                    { "name": "娇嫩舌", "index": "1.3.2" },
                    { "name": "胖大舌", "index": "1.3.3" },
                    { "name": "瘦薄舌", "index": "1.3.4" },
                    { "name": "齿痕舌", "index": "1.3.5" },
                    { "name": "肿胀舌", "index": "1.3.6" },
                    { "name": "点、刺舌", "index": "1.3.7" },
                    { "name": "裂纹舌", "index": "1.3.8" }]
            },
            {
                "name": "舌态",
                "label": "态",
                "ifShowThird": false,
                "index": "1.4",
                "children": [{ "name": "痿软舌", "index": "1.4.1" },
                { "name": "强硬舌", "index": "1.4.2" },
                { "name": "歪斜舌", "index": "1.4.3" },
                { "name": "颤动舌", "index": "1.4.4" },
                { "name": "吐弄舌", "index": "1.4.5" },
                { "name": "短缩舌", "index": "1.4.6" }]
            },
            {
                "name": "舌下络脉",
                "label": "脉",
                "ifShowThird": false,
                "index": "1.5",
                "children": [{ "name": "正常舌脉", "index": "1.5.1" }]
            },
        ]
    },
    {
        "name": "望舌苔",
        "index": "2",
        "ifShowSecond": false,
        "children": [
            {
                "name": "苔质", "label": "质", "ifShowThird": false, "index": "2.1", "children": [
                    { "name": "薄苔", "index": "2.1.1" },
                    { "name": "厚苔", "index": "2.1.2" },
                    { "name": "润苔", "index": "2.1.3" },
                    { "name": "燥苔", "index": "2.1.4" },
                    { "name": "腻苔", "index": "2.1.5" },
                    { "name": "腐苔", "index": "2.1.6" },
                    { "name": "剥落苔", "index": "2.1.7" },
                    { "name": "偏苔", "index": "2.1.8" },
                    { "name": "全苔", "index": "2.1.9" },
                    { "name": "真苔", "index": "2.1.10" },
                    { "name": "假苔", "index": "2.1.11" },
                ]
            },
            {
                "name": "苔色", "label": "色", "ifShowThird": false, "index": "2.2", "children": [
                    { "name": "白苔", "index": "2.2.1" },
                    { "name": "黄苔", "index": "2.2.2" },
                    { "name": "灰黑苔", "index": "2.2.3" },
                ]
            },
        ]
    },
    {
        "name": "望面",
        "index": "3",
        "ifShowSecond": true,
        "children": [
            {
                "name": "面色", "label": "面色", "ifShowThird": false, "index": "3.1", "children": [
                    { "name": "面色红", "index": "3.1.1" },
                    { "name": "面色黄", "index": "3.1.2" },
                    { "name": "面色萎黄", "index": "3.1.3" },
                    { "name": "面色白", "index": "3.1.4" },
                ]
            },
            {
                "name": "局部面部特征", "label": "局部面部特征", "ifShowThird": false, "index": "4.1", "children": [
                    { "name": "两颧红", "index": "4.1.1" },
                    { "name": "眼眶黑", "index": "4.1.2" },
                ]
            },
            {
                "name": "光泽", "label": "光泽", "ifShowThird": false, "index": "5.1", "children": [
                    { "name": "有光泽", "index": "5.1.1" },
                    { "name": "无光泽", "index": "5.1.2" },
                ]
            },
            {
                "name": "唇色", "label": "唇色", "ifShowThird": false, "index": "6.1", "children": [
                    { "name": "唇色暗红", "index": "6.1.1" },
                    { "name": "唇色青紫", "index": "6.1.2" },
                    { "name": "唇色淡", "index": "6.1.3" },
                ]
            }
        ]
    }
];
